export default (function () {
	var handlers = [];

	var sideEffectsMiddleware = function sideEffectsMiddleware(store) {
		return function (next) {
			return function (action) {
				var result = next(action);

				handlers.forEach(function (handler) {
					handler(action, store);
				});

				return result;
			};
		};
	};

	sideEffectsMiddleware.add = function (handler) {
		handlers.push(handler);
	};

	return sideEffectsMiddleware;
});